// Filter state of the Rollo queue. Values are kept as strings exactly as the selects and inputs hold them;
// responsable "0" means "Sin asignar" (the API reads responsableUsuarioId = 0 that way).

export const VISTAS = {
  ACTIVAS: "activas",
  FINALIZADAS: "finalizadas",
};

export const PAGE_SIZE = 50;

export const EMPTY_FILTERS = {
  estado: "",
  prioridad: "",
  responsable: "",
  provincia: "",
  origen: "",
  resultado: "",
  cierreDesde: "",
  cierreHasta: "",
};

const SHARED_KEYS = ["responsable", "provincia", "origen"];
const VIEW_KEYS = {
  [VISTAS.ACTIVAS]: ["estado", "prioridad"],
  [VISTAS.FINALIZADAS]: ["resultado", "cierreDesde", "cierreHasta"],
};

// Filters that apply to a view (the view's own ones plus the shared ones).
export const filterKeysFor = (vista) => [...(VIEW_KEYS[vista] || []), ...SHARED_KEYS];

const VIEW_ONLY_KEYS = Object.values(VIEW_KEYS).flat();

// Switching views resets the filters whose options change with the view (Estado, Prioridad, Resultado and the
// close range) and keeps the search, Responsable, Provincia and Origen (design rule, S9).
export const resetViewFilters = (filters) => ({
  ...filters,
  ...Object.fromEntries(VIEW_ONLY_KEYS.map((key) => [key, EMPTY_FILTERS[key]])),
});

export const countActiveFilters = (filters, vista) => filterKeysFor(vista).filter((key) => filters[key]).length;

export const buildListQuery = ({ vista, texto, filters, pagina, tamanoPagina = PAGE_SIZE }) => {
  const query = { vista, pagina, tamanoPagina };
  if (texto) query.texto = texto;
  if (filters.responsable !== "") query.responsableUsuarioId = filters.responsable;
  if (filters.provincia) query.provincia = filters.provincia;
  if (filters.origen) query.origen = filters.origen;

  if (vista === VISTAS.FINALIZADAS) {
    if (filters.resultado) query.resultado = filters.resultado;
    if (filters.cierreDesde) query.cierreDesde = filters.cierreDesde;
    if (filters.cierreHasta) query.cierreHasta = filters.cierreHasta;
  } else {
    if (filters.estado) query.estado = filters.estado;
    if (filters.prioridad) query.prioridad = filters.prioridad;
  }

  return query;
};

// "Exportar Excel" exports Finalizadas with the same filters as the list, without paging.
export const buildExportQuery = ({ texto, filters }) => {
  const { pagina, tamanoPagina, ...query } = buildListQuery({ vista: VISTAS.FINALIZADAS, texto, filters, pagina: 1 });
  return query;
};

// "Ver todas" of the detail: Finalizadas of one comercio (by CUIT) with Resultado Entregado.
export const entregadasFilters = () => ({ ...EMPTY_FILTERS, resultado: "ENTREGADO" });
